import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../auth/Login";
import HomePage from "./HomePage";
const HomeIndex = () => {
  return (
    <div>
      <AuthenticatedTemplate>
        <HomePage />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default HomeIndex;
